import { useQuery } from '@tanstack/react-query';

import { reportingEscalationApi } from '../api/reportingEscalationApi';

export function useEscalationReport() {
  return useQuery({
    queryKey: ['escalation-report'],
    queryFn: () => reportingEscalationApi.getEscalationReport(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
  });
}
